import { pick } from 'es-toolkit';
import { appStateKeys, createAppStore } from './appStore';
import { createFavoritesStore, favoritesStateKeys } from './favoritesStore';
import { createPlayerStore, playerStateKeys } from './playerStore';
import type { InitialStoresState, IStores } from './types';
import { createUserStore, userStateKeys } from './userStore';
import { withSelectors } from './utils/withSelectors';

export function createStores(initialState: InitialStoresState = {}): IStores {
  return {
    appStore: withSelectors(createAppStore(initialState.appStore)),
    playerStore: withSelectors(createPlayerStore(initialState.playerStore)),
    favoritesStore: withSelectors(createFavoritesStore(initialState.favoritesStore)),
    userStore: withSelectors(createUserStore(initialState.userStore)),
  };
}

/** The allow-listed state of every store, as it is serialized into the page. */
export function getStoresState(stores: IStores): InitialStoresState {
  return {
    appStore: pick(stores.appStore.getState(), appStateKeys),
    playerStore: pick(stores.playerStore.getState(), playerStateKeys),
    favoritesStore: pick(stores.favoritesStore.getState(), favoritesStateKeys),
    userStore: pick(stores.userStore.getState(), userStateKeys),
  };
}
